'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002epages$002esign$002e$002dSign$002dView$0024$0024anon$002418 from "./presto.pages.sign.-Sign-View$$anon$18.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_sign_SignView$$anon$17(outer) {
  this.bVL = null;
  this.bVJ = null;
  this.bVK = false;
  this.bVH = null;
  this.bVI = false;
  this.bVM = false;
  this.bVN = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bVL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_sign_SignView$$anon$17 as $c_Lpresto_pages_sign_SignView$$anon$17 };
$p = $c_Lpresto_pages_sign_SignView$$anon$17.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_sign_SignView$$anon$17;
/** @constructor */
function $h_Lpresto_pages_sign_SignView$$anon$17() {
}
export { $h_Lpresto_pages_sign_SignView$$anon$17 as $h_Lpresto_pages_sign_SignView$$anon$17 };
$h_Lpresto_pages_sign_SignView$$anon$17.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bVL;
});
$p.t = (function() {
  if ((!this.bVK)) {
    this.bVJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("groups", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bVK = true;
  }
  return this.bVJ;
});
$p.ad = (function() {
  if ((!this.bVI)) {
    this.bVH = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().gI(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002epages$002esign$002e$002dSign$002dView$0024$0024anon$002418.$c_Lpresto_pages_sign_SignView$$anon$18()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bVI = true;
  }
  return this.bVH;
});
$p.v = (function() {
  if ((!this.bVN)) {
    this.bVM = false;
    this.bVN = true;
  }
  return this.bVM;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_sign_SignView$$anon$17 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_sign_SignView$$anon$17, "presto.pages.sign.SignView$$anon$17", ({
  Xo: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_sign_SignView$$anon$17 as $d_Lpresto_pages_sign_SignView$$anon$17 };
//# sourceMappingURL=presto.pages.sign.-Sign-View$$anon$17.js.map
